import React, { Component } from 'react';
import { Card, Elevation, Tag, HTMLTable, Button, Intent } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';
import Inventory from '../Components/Inventory';

export default class Character extends Component {
  constructor(props) {
    super(props);
    const charName = (props.match && props.match.params && props.match.params.Character) || 'Nozich';
    this.state = {
      characterName: charName,
    };
  }

  render() {
    return (
      <SideMenuWrapper>
        {/* Character Header Card */}
        <Card elevation={Elevation.TWO} className="mb-4">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <div className="d-flex align-items-center gap-2">
                <h3 className="m-0 font-weight-bold" style={{ color: '#182026' }}>{this.state.characterName}</h3>
                <Tag intent={Intent.SUCCESS} round>ONLINE</Tag>
                <Tag intent={Intent.WARNING} minimal>Chinese Bower/Fire</Tag>
              </div>
              <p className="m-0 mt-1" style={{ fontSize: '0.85rem', color: '#5c7080' }}>
                Guild: <strong style={{ color: '#106ba3' }}>SROFilter_Guild</strong> • Level: <strong className="text-warning">Lv. 110 Cap</strong> • Location: <strong>Taklamakan (X: 1490, Y: 820)</strong>
              </p>
            </div>
            <Button icon="arrow-left" text="Back to Players List" onClick={() => window.history.back()} minimal small />
          </div>
        </Card>

        {/* Character Stats & Finances Grid */}
        <div className="row mb-4">
          <div className="col-md-3">
            <Card elevation={Elevation.ONE} className="p-3">
              <span className="text-muted d-block text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 700 }}>Inventory Gold</span>
              <h4 className="m-0 text-warning" style={{ fontWeight: 800 }}>1.45 Bil Gold</h4>
            </Card>
          </div>
          <div className="col-md-3">
            <Card elevation={Elevation.ONE} className="p-3">
              <span className="text-muted d-block text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 700 }}>Bank Storage Gold</span>
              <h4 className="m-0 text-warning" style={{ fontWeight: 800 }}>1.00 Bil Gold</h4>
            </Card>
          </div>
          <div className="col-md-3">
            <Card elevation={Elevation.ONE} className="p-3">
              <span className="text-muted d-block text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 700 }}>Silk Balance</span>
              <h4 className="m-0 text-info" style={{ fontWeight: 800 }}>12,800 Silk</h4>
            </Card>
          </div>
          <div className="col-md-3">
            <Card elevation={Elevation.ONE} className="p-3">
              <span className="text-muted d-block text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 700 }}>Unique Kills</span>
              <h4 className="m-0 text-success" style={{ fontWeight: 800 }}>142 Uniques</h4>
            </Card>
          </div>
        </div>

        {/* Character Equipment Inventory View */}
        <div className="mb-4">
          <h4 className="mb-2 font-weight-bold" style={{ fontSize: '1.1rem', color: '#182026' }}>
            Equipment & Item Inventory
          </h4>
          <Inventory />
        </div>

        {/* Recent Character Security Logs */}
        <div>
          <h4 className="mb-2 font-weight-bold" style={{ fontSize: '1.1rem', color: '#182026' }}>
            Recent Activity & Security Log
          </h4>
          <HTMLTable bordered condensed striped style={{ width: '100%', fontSize: '0.82rem' }}>
            <thead>
              <tr>
                <th style={{ color: '#182026' }}>Timestamp</th>
                <th style={{ color: '#182026' }}>Event Type</th>
                <th style={{ color: '#182026' }}>Details</th>
                <th style={{ color: '#182026' }}>IP Address</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ color: '#5c7080' }}>14:42:01</td>
                <td><Tag intent={Intent.SUCCESS}>LOGIN</Tag></td>
                <td style={{ color: '#182026' }}>Successfully authenticated via Gateway (Hardware ID verified)</td>
                <td className="font-mono" style={{ color: '#5c7080' }}>85.102.**.**</td>
              </tr>
              <tr>
                <td style={{ color: '#5c7080' }}>14:39:45</td>
                <td><Tag intent={Intent.PRIMARY}>PURCHASE</Tag></td>
                <td style={{ color: '#182026' }}>Purchased 10,000 Silk Package via PayTR</td>
                <td className="font-mono" style={{ color: '#5c7080' }}>85.102.**.**</td>
              </tr>
              <tr>
                <td style={{ color: '#5c7080' }}>13:10:12</td>
                <td><Tag intent={Intent.WARNING}>UNIQUE_KILL</Tag></td>
                <td style={{ color: '#182026' }}>Killed Unique Monster Demon Shaitan in Roc Mountain</td>
                <td className="font-mono" style={{ color: '#5c7080' }}>85.102.**.**</td>
              </tr>
            </tbody>
          </HTMLTable>
        </div>
      </SideMenuWrapper>
    );
  }
}
